import { CartItem, CartRepository } from "../../domain";
import { CartLocalDataSource } from "../data-sources";

export class CartRepositoryImpl implements CartRepository {
  constructor(private readonly localDataSource: CartLocalDataSource) {}

  public loadCartItems(): CartItem[] {
    return this.localDataSource.loadCartItems();
  }

  public addToCart(
    productId: string,
    attributeId: string,
    count: number
  ): void {
    this.localDataSource.addToCart(productId, attributeId, count);
  }

  public removeFromCart(productId: string, attributeId: string): void {
    this.localDataSource.removeFromCart(productId, attributeId);
  }

  public increaseCount(productId: string, attributeId: string): void {
    this.localDataSource.increaseCount(productId, attributeId);
  }

  public decreseCount(productId: string, attributeId: string): void {
    this.localDataSource.decreaseCount(productId, attributeId);
  }

  public clearCart(): void {
    this.localDataSource.clearCart();
  }
}
